import { useRef, useState } from 'react';
import CardRounded from '../CardRounded/CardRoundedComponent';
import Flex from '../Flex/FlexComponent';
import Button from '../Button/ButtonComponent';
import Textarea from '../Textarea/TextareaComponent';
import Checkbox from '../Checkbox/CheckboxComponent';
import SelectComponent from '../Select';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useRouter } from 'next/router';
import { removeBlankSpaces, removeAccentsAndLowercase } from '../../utils/utils';
import { useRedl } from 'hooks/useRedl';
import { useDelivertyUser } from 'hooks/useDelivertyUser';
import Select from 'react-select';

export default function EditarFontDeDadesComponent({ handleSave }) {
    const ref = useRef();
    const { showRightSidePanel, setShowRightSidePanel } = useRedl();
    const router = useRouter();
    const { getRedlPageRawLayout } = useRedlMetadata(router.pathname);
    const { allData } = getRedlPageRawLayout();
    const selectData = [];
    const { userData } = useDelivertyUser();
    const [selectOptions, setSelectOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    Object.keys(allData[0]?.main || {})
        .sort()
        .forEach(function (key) {
            selectData.push({ value: key, label: key, url: allData[0]?.main[key]?.url });
        });

    const [fontDeDades, setFontDeDades] = useState({
        value: showRightSidePanel.fontDeDades?.source?.name,
        label: showRightSidePanel.fontDeDades?.source?.name,
        url: showRightSidePanel.fontDeDades?.source?.url
    });

    const handleInputChange = (e) => {
        setFontDeDades((prevState) => ({ ...prevState, url: removeBlankSpaces(e.target.value) }));
    };

    const handleSelectChange = (option) => {
        setFontDeDades({
            value: removeBlankSpaces(option?.value),
            label: removeBlankSpaces(option?.label),
            url: removeBlankSpaces(option?.url)
        });
    };

    const onSave = () => {
        handleSave({ newSource: fontDeDades, oldSource: showRightSidePanel.fontDeDades?.source, propagateSource: isChecked });
    };

    const getSelectOptions = async (value) => {
        const urlParams = new URLSearchParams(window.location.search);
        const isDelivertyBeta = urlParams.get('dty-beta') === 'true';
        const prefixApi = isDelivertyBeta ? window.jitConfig.apiDELIVERTYBeta : window.jitConfig.apiDELIVERTY;
        const pathApi = `/continguts/DTY_COLLECCIO/_autocompletat?text=${value}`;
        const dataLogin = {
            items: 50,
            filtres: { DOMAIN: ['N324', 'senseDomini'], STATE: ['PUB', 'PUBNC'] },
            camps: ['UPDATED']
        };

        const response = await fetch(`${prefixApi}${pathApi}`, {
            method: 'POST',
            body: JSON.stringify(dataLogin),
            headers: {
                'Content-Type': 'application/json',
                'accept': '*/*',
                'authorization': `Bearer ${userData?.token}`
            }
        });
        const data = await response.json();
        if (data?.resultats !== undefined) {
            const options = data.resultats.map((item) => ({
                value: item.id,
                label: item.camps.TITOL + ' - ' + item.id + ' - ' + item.camps.STATE.NAME
            }));
            setSelectOptions(options);
            setIsLoading(false);
        } else {
            console.error("Error fent la crida a l'api de deliverty");
        }
    };

    const [isChecked, setIsChecked] = useState(showRightSidePanel.fontDeDades?.blocConfig?.propagateSource ?? false);
    let timeoutId;

    const handleInputDadesChange = (value) => {
        if (value.length > 2) {
            setIsLoading(true);
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                getSelectOptions(value);
            }, 500);
        }
    };

    function replaceIdInString(url, newId) {
        return url.replace(/(\?|&)id=\d+(&|$)/, `$1id=${newId}$2`);
    }

    const handleSelectDadesChange = (option) => {
        if (option === null) {
            setSelectOptions([]);
        } else {
            let labelSplit = option.label.split(' - ');
            let id = removeAccentsAndLowercase(removeBlankSpaces(labelSplit[0] + labelSplit[1]));
            setFontDeDades((prevState) => ({ ...prevState, url: replaceIdInString(fontDeDades.url, option.value) }));
            setFontDeDades({
                value: id,
                label: id,
                url: replaceIdInString(fontDeDades.url, option.value)
            });
        }
    };

    const isColleccio = fontDeDades?.url?.includes('origen=colleccio') || false;

    return (
        <CardRounded
            height='100%'
            action='edit'
            closed
            onCancel={() => {
                setShowRightSidePanel((prevState) => ({ ...prevState, size: 'xl', fontDeDades: undefined }));
            }}
        >
            <form
                onSubmit={(e) => {
                    e.preventDefault();

                    const confirmaGuardar = isChecked
                        ? window.confirm('Vols aplicar la mateixa font de dades per a totes les posicions?')
                        : true;

                    if (confirmaGuardar) {
                        onSave();
                    }
                }}
                ref={ref}
            >
                {isColleccio && (
                    <Flex margin='0 0 8px 0' padding='8px 0 0 0'>
                        <Select
                            className='basic-single'
                            classNamePrefix='select'
                            name='color'
                            options={selectOptions}
                            onInputChange={handleInputDadesChange}
                            onChange={handleSelectDadesChange}
                            isClearable={true}
                            isSearchable={true}
                            isLoading={isLoading}
                            placeholder='Cercador de fonts de dades'
                        />
                    </Flex>
                )}
                <Flex margin='0 0 8px 0'>
                    <SelectComponent
                        label='Font de dades'
                        value={fontDeDades}
                        options={selectData}
                        onChange={handleSelectChange}
                    />
                </Flex>
                <Flex margin='0 0 8px 0'>
                    <Textarea label='url' value={fontDeDades?.url} onChange={handleInputChange} ref={ref} />
                </Flex>
                <Flex margin='0 0 8px 0' padding='8px 0 0 0'>
                    <Checkbox
                        checkboxId='checkboxMateixOrigen'
                        checkboxValue='checbox_mateixOrigen'
                        textLabel='Aplicar el mateix origen per la resta'
                        isChecked={isChecked}
                        setIsChecked={setIsChecked}
                    ></Checkbox>
                </Flex>
                <Flex container alignItems='center' justifyContent='center' padding='24px 0 0 0'>
                    <Button
                        variant='tertiary'
                        size='sm-lg'
                        type='reset'
                        style={{ marginRight: '1rem' }}
                        onClick={() =>
                            setShowRightSidePanel((prevState) => ({
                                ...prevState,
                                size: 'xl',
                                fontDeDades: undefined
                            }))
                        }
                    >
                        Cancel·la
                    </Button>
                    <Button variant='secondary' size='sm-lg' type='submit' disabled={!fontDeDades?.value || !fontDeDades?.url}>
                        Guardar
                    </Button>
                </Flex>
            </form>
        </CardRounded>
    );
}
